import { useContext } from 'react';
import { ToggleUploadDisplayContext } from '@trinity/chat-components/containers/WorkspaceFileUpload/Context.js';

export const useToggleUploadDisplay = () => {
  const toggle = useContext(ToggleUploadDisplayContext);

  return toggle;
};

export default useToggleUploadDisplay;